export const removeDuplicatesFromObjectArrayBasedOnKey = <T>(arr: T[], uniqueKey: keyof T): T[] =>
{
  const uniqueObjects: T[] = [];
  const keys: any[] = [];

  for(const obj of arr)
  {
    if(!keys.includes(obj[uniqueKey]))
    {
      uniqueObjects.push(obj);
      keys.push(obj[uniqueKey]);
    }
  }

  return uniqueObjects;
};

